<div class="gallery user_images_gallery">
    <div class="upload_btn drop-area">
    <file-upload
    name="files[]"
    :post-action="uploadUserPhotoUrl"
    :data="{customer: customer}"
    :multiple="true"
     v-model="files"
     @input-file="inputFile"
     ref="upload">
        {{$t('Upload your own files')}}       
    </file-upload>
    </div>
    <appImageEditorGallery :items="items" :hideDelete="false" />
</div>